module.exports = __webpack_public_path__ + "img/icono-message-automatic.0a78d876.svg";